import Image from 'next/image'
import type { RichTextField } from '@prismicio/client'
import RichTextSerializer from '@components/RichTextSerializer'
import CloudBadge from './CloudBadge'

interface Feature {
	text: string
}

interface SubscriptionPlanCardProps {
	imageUrl: string
	badgeText?: string
	badgeValue?: number
	title: RichTextField
	subtitle: RichTextField
	deliveryFrequency: string
	features: Feature[]
	price: string
	priceSubtext?: string
	ctaText: string
	href: string
}

export default function SubscriptionPlanCard({
	imageUrl,
	badgeText,
	badgeValue,
	title,
	subtitle,
	deliveryFrequency,
	features,
	price,
	priceSubtext,
	ctaText,
	href
}: SubscriptionPlanCardProps) {
	return (
		<div className="text-bbx-stylerounded-xl border border-gray-100 flex flex-col flex-1 max-w-[430px] font-sans">
			<div className="relative flex flex-col items-center">
				<div className="relative w-full aspect-square bg-gray-50">
					<Image
						src={imageUrl}
						alt={Array.isArray(title) && title[0] && 'text' in title[0] ? title[0].text : ''}
						fill
						className="object-contain"
						sizes="(max-width: 430px) 100vw, 430px"
					/>
				</div>
				{badgeText && badgeValue && (
					<div className="absolute -top-4 -right-4 z-10">
						<CloudBadge badgeText={badgeText} badgeValue={badgeValue} />
					</div>
				)}
			</div>
			<div className="bg-white p-11 flex flex-col flex-1">
				<div className="text-3xl md:text-4xl mb-2">
					<RichTextSerializer content={title} />
				</div>
				<div className="mb-8 text-xl opacity-80">
					<RichTextSerializer content={subtitle} />
				</div>
				{/* <p className="text-base mb-4 font-medium opacity-80">{subtitle}</p> */}
				<ul className="mb-8 space-y-2">
					<li key="delivery-frequency" className="flex items-center text-md list-item-clock ">
						{deliveryFrequency}
					</li>
					{features?.map((feature) => (
						<li key={feature.text} className="flex items-center text-md list-item-tick">
							{feature.text}
						</li>
					))}
				</ul>
				<div className="mb-8">
					<div className="text-base mb-1">Starting At</div>
					<span className="text-3xl font-bold">{price}</span>
					{priceSubtext && <span className="text-sm ml-1">{priceSubtext}</span>}
				</div>
				<a className="button button-dark-blue" href={href} type="button">
					{ctaText}
				</a>
			</div>
		</div>
	)
}
